'use client';
import { Import, ImportRecap } from '@/containers';
import { NotifsContext } from '@/contexts';
import { useImportEmployeesMutation } from '@/services/API';
import { APIMessage } from '@/types';
import { jsonToCsv } from '@/utils/files';
import { useContext, useState } from 'react';

export default function Page() {
  const { addToast } = useContext(NotifsContext);

  const [importEmployees, { isLoading: isImportLoading }] =
    useImportEmployeesMutation();

  const [filesToDownload, setFilesToDownload] = useState<
    { content: string; fileName: string }[]
  >([]);
  const [importedFiles, setImportedFiles] = useState<boolean>(false);

  function onImport(file: FormData) {
    importEmployees(file)
      .unwrap()
      .then((response) => {
        const createdLines = response.resources.filter(
          (element) => element.message === APIMessage.OK
        );
        const duplicatedLines = response.resources.filter(
          (element) => element.message === APIMessage.UNIQUENESS
        );
        const resultWithPsw = response.resources.map(
          ({ user_password = '' }) => ({
            user_password,
          })
        );
        const formatedResult = response.resources.map(
          ({ uid, message, description = '' }) => ({
            uid,
            message,
            description,
          })
        );
        setFilesToDownload([
          {
            content: jsonToCsv(resultWithPsw),
            fileName: 'result_with_psw.csv',
          },
          {
            content: jsonToCsv(formatedResult),
            fileName: 'all_result.csv',
          },
        ]);

        setImportedFiles(true);
        addToast &&
          addToast({
            toastType: 'success',
            children: (
              <p className="bold">
                Confirmation de traitement du fichier (
                {response.resources.length} éléments). <br />
                {createdLines.length} éléments créés.
                <br />
                {duplicatedLines.length} éléments déjà existant.
              </p>
            ),
          });
      })

      .catch((response) => {
        let errorMsg = '';
        try {
          errorMsg = '(' + response.data[0].error_description + ')';
        } catch (error) {}
        addToast &&
          addToast({
            toastType: 'error',
            children:
              `Une erreur est survenue.
            Rééssayer ultérieurement ` + errorMsg,
          });
      });
  }

  return !importedFiles ? (
    <Import
      title={'2. Importer une liste des administrateurs'}
      modelLink={'/csv/ppid_import_employee-v1.csv'}
      onImport={onImport}
      isImportLoading={isImportLoading}
    />
  ) : (
    <ImportRecap files={filesToDownload} />
  );
}
